import { recipe } from "@vanilla-extract/recipes";

import { spacingVariants } from "../../utils/vanilla/spacingVariants";

export const spacingStyle = recipe({
  base: {},
  variants: {
    height: spacingVariants("height"),
    width: spacingVariants("width"),
    grow: {
      true: {
        flexGrow: 1,
      },
      false: {},
    },
    shrink: {
      true: {
        flexShrink: 1,
      },
      false: {},
    },
  },
  defaultVariants: {
    grow: false,
    shrink: false,
  },
});
